'use client'

import Image from 'next/image'

const Icon = ({ name, alt = '', width = 12, height = 12, ...props }) => {
  if (!name) return { src: null }

  const src = `/oferta/icons/${name}.svg`

  if (!src) return null

  return <Image src={src} alt={alt} width={width} height={height} {...props} />
}

export default Icon
